let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lmm7J")).then(() => parcelRequire('ddvLU'));